export default __webpack_public_path__ + "static/media/fauna-index-quote.179f874a.png";